import type { FunctionComponent, HTMLAttributes, MouseEvent } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { IconButton, Icons } from '../iconButton/IconButton';

import styles from './BackButton.module.css';

export interface BackButtonProps extends HTMLAttributes<HTMLButtonElement> {
  visible?: boolean;
}

export const BackButton: FunctionComponent<BackButtonProps> = ({ onClick, visible, className = '' }) => {
  const mods = useModifiers(styles, 'backButton', { visible });

  return (
    <div data-testid="back-button" className={`${styles.backButton} ${mods} ${className}`}>
      <IconButton
        small
        ghost
        icon={Icons.ChevronLeft}
        onClick={(event): void => {
          if (onClick) {
            onClick(event as MouseEvent<HTMLButtonElement>);
          }
        }}
      />
      {/*<Icon icon={Icons.ChevronLeft} />*/}
      {/*<span className={styles.backButton__label}>*/}
      {/*  <L12nText tk="BACK" />*/}
      {/*</span>*/}
    </div>
  );
};
